import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/useAuth';
import { LoadingState } from '../../../shared/components/ui/LoadingState';

interface PublicOnlyRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const PublicOnlyRoute: React.FC<PublicOnlyRouteProps> = ({
  children,
  redirectTo = '/dashboard',
}) => {
  const { user, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  const [hasCheckedAuth, setHasCheckedAuth] = useState(false);

  useEffect(() => {
    // Only check auth once when loading is complete
    if (!loading && !hasCheckedAuth) {
      setHasCheckedAuth(true);
      
      // If user is authenticated after loading is complete, redirect them away from auth pages
      if (isAuthenticated && user) {
        navigate(redirectTo, { replace: true });
      }
    }
  }, [isAuthenticated, user, loading, navigate, redirectTo, hasCheckedAuth]);

  // Show loading state only during initial auth loading
  if (loading) {
    return <LoadingState message="Loading application..." />;
  }

  // If user is authenticated, don't render the children (they'll be redirected)
  if (isAuthenticated && user) {
    return null;
  }

  // User is not authenticated, show the auth page
  return <>{children}</>;
};
